import { graphql } from 'gatsby';
import React from 'react';
import TrustBox from './rating/TrustpilotWidget';

const Stars = ({ block, vars }) => {
  let styleClassName = '';
  if (block.css_overrides) {
    styleClassName = block.css_class_name;
  }

  let positionClass = '';
  if (block.position === 'Overlay') {
    positionClass = 'pos-overlay';
  } else {
    positionClass = 'pos-standalone';
  }

  let backgroundClass = '';
  if (block.background_color === 'None') {
    backgroundClass = 'bg-none';
  } else if (block.background_color === 'Transparent') {
    backgroundClass = 'bg-transparent';
  } else if (block.background_color === 'White' || !block.background_color) {
    backgroundClass = 'bg-white';
  }

  let ratingText = vars.trustpilot_rating_text;
  if (block.rating_text) {
    ratingText = block.rating_text;
  }

  let rating = vars.trustpilot_rating;
  if (block.rating) {
    rating = block.rating;
  }

  let reviews = vars.trustpilot_reviews;
  if (block.reviews) {
    reviews = block.reviews;
  }

  let themeClass = '';
  if (block.theme) {
    themeClass = `stars--${block.theme}`;
  }

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${styleClassName} ${positionClass} ${backgroundClass} ${themeClass}`}
    >
      <div
        className='container'
        style={{
          background: backgroundClass ? '' : block.background_color,
        }}
      >
        <div className='stars-wr'>
          {(block.title || block.subtitle) && (
            <div
              className={`content-wr ${block.show_text_mobile ? '' : 'is-desktop'}`}
            >
              {block.title && <h4>{block.title}</h4>}
              {block.subtitle && <p>{block.subtitle}</p>}
            </div>
          )}

          <TrustBox
            theme='light'
            type={'53aa8807dec7e10d38f59f32'}
          />
          {/* {themeClass.length === 0 ? (
            <StarsByVars vars={vars} />
          ) : (
            <StarsByTheme
              ratingText={ratingText}
              rating={rating}
              reviews={reviews}
              logo={block.logo}
            />
          )} */}
        </div>
      </div>
    </section>
  );
};

// const StarsByVars = ({ vars }) => {
//   return (
//     <div className='stars'>
//       <a
//         href='https://www.trustpilot.com/review/bunny.net'
//         target='_blank'
//         rel='noopener'
//       ></a>
//       <p className='above'>
//         We're rated{' '}
//         <strong>
//           {vars.trustpilot_rating_text} {vars.trustpilot_rating}
//         </strong>{' '}
//         <i className='fa fa-star is-mobile'></i>
//       </p>
//       <div className='icons is-desktop'>
//         <Star />
//         <Star />
//         <Star />
//         <Star />
//         <Star />
//       </div>
//       <p className='below'>
//         {vars.trustpilot_rating} out of 5 based on {vars.trustpilot_reviews}{' '}
//         reviews
//       </p>
//     </div>
//   );
// };

// const StarsByTheme = ({ ratingText, rating, reviews, logo }) => {
//   const stars = new Array(5).fill(1);

//   return (
//     <div className='stars'>
//       <a
//         className='stars__link'
//         href='https://www.trustpilot.com/review/bunny.net'
//         target='_blank'
//         rel='noopener'
//       >
//         <div className='above'>
//           {logo && (
//             <img
//               className='stars__logo'
//               src={logo.icon}
//               alt={logo.title}
//             />
//           )}
//           <p className='stars__title'>
//             bunny.net is rated{' '}
//             <strong>
//               {ratingText} {rating}
//             </strong>
//           </p>
//         </div>
//         <div className='bottom'>
//           <p className='stars__text'>
//             <span className='bold'>{rating}</span> out of 5 based on{' '}
//             <span className='bold'>{reviews}</span> reviews
//           </p>
//           <div className='stars__icons stars__icons--bg is-desktop'>
//             <div className='stars__bar' />
//             {stars.map((star, index) => (
//               <Star key={index} />
//             ))}
//           </div>
//         </div>
//       </a>
//     </div>
//   );
// };

const Star = () => {
  return (
    <i
      role='img'
      alt='TrustPilot Review'
      title='TrustPilot Review'
      className='fa fa-star'
    />
  );
};

export const starsFragment = graphql`
  fragment StarsFragment on Stars {
    _template
    background_color
    logo {
      title
      icon
    }
    position
    subtitle
    theme
    title
  }
`;

export default Stars;
